<template>
  <div class="wrapper border-bottom white-bg page-heading">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-10 col-lg-11">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else><i class="far fa-id-card m-r-sm"></i> {{ driver.name }}</h1>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import { mapState } from 'vuex'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [headingLoading],

    computed: mapState('driver', ['driver'])
  }
</script>



// WEBPACK FOOTER //
// EditHeading.vue?31280295